/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table';
import moment from 'moment';
import RefreshButton from '../../common/refreshbutton';
import SearchBar from '../common/SearchBar';
import { withPushFiltersToUrl } from '../common/decorators';
import history from '../../../history';
import { BaseDropDown } from '../common/dropdowns';
import { executeHttpRequest } from '../../../epics/api';


const selfServeOptions = [
    { label: 'All clients', value: '' },
    { label: 'Self-serve clients', value: 'true' },
];

@withPushFiltersToUrl
export default class ClientsTable extends Component {

    constructor(props) {
        super(props);
        this.state = { clientCategories: [] };
    }

    componentDidMount() {
        this.fetchClientCategories();
    }

    fetchClientCategories() {
        executeHttpRequest('client-categories/')
            .then(res => this.setState({ clientCategories: res.data.content }));
    }

    render() {
        const currentUrlParams = new URLSearchParams(history.location.search);

        return (
            <div className="table-container">
                <div className="table-filter-container">
                    <BaseDropDown
                        filterKey="self_serve"
                        selected={currentUrlParams.get('self_serve')}
                        options={selfServeOptions}
                        defaultSelection={selfServeOptions[0]}
                        onFilterChange={this.props.onFilterChange}
                    />
                    <SearchBar
                        filterKey="search"
                        onFilterChange={this.props.onFilterChange}
                        currentUrlParams={currentUrlParams}
                    />
                    <div className="table-action-bar">
                        <RefreshButton reloadData={this.props.reloadData} />
                    </div>
                </div>
                <ReactTable
                    page={this.props.currentPage}
                    pageSize={0}
                    data={this.props.data}
                    pages={this.props.pages}
                    columns={this.tableColumns}
                    className="table-content"
                    loading={this.props.loading}
                    showPaginationBottom={this.props.showPaginationBottom}
                    showPageSizeOptions={false}
                    manual={true}
                    onPageChange={this.props.onPageChange}
                    onSortedChange={this.props.onSortedChange}
                />
            </div>
        );
    }

    tableColumns = [
        {
            Header: 'Ref',
            accessor: 'id',
            headerClassName: 'ref-margin-left small-col',
            className: 'ref-margin-left small-col',
            Cell: row => (
                <div>
                    <Link
                        className="group-link"
                        to={`/operations/client/${row.original.id}`}
                    >
                        {row.original.reference_number}
                    </Link>
                </div>
            ),
        },
        {
            Header: 'Logo',
            accessor: 'logo',
            sortable: false,
            headerClassName: 'xsmall-col',
            className: 'xsmall-col',
            Cell: row => {
                const logo = row.original.logo
                    ? row.original.logo
                    : '/static/images/default_profile.png';
                return (
                    <div>
                        <a
                            className="group-link"
                            href={logo}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <div
                                className="avatar"
                                style={{ backgroundImage: `url(${logo})` }}
                            />
                        </a>
                    </div>
                );
            },
        },

        {
            Header: 'Company',
            accessor: 'company_name',
        },
        {
            Header: 'Contact',
            accessor: 'first_name',
            headerClassName: 'large-col',
            className: 'large-col',
            Cell: row => (
                <span>
                    {row.original.first_name} {row.original.last_name}
                </span>
            ),
        },
        {
            Header: 'Mobile',
            accessor: 'mobile',
            headerClassName: 'small-col',
            className: 'small-col',
            sortable: false,
        },
        {
            Header: 'Date Joined',
            accessor: 'user__date_joined',
            headerClassName: 'small-col',
            className: 'small-col',
            Cell: row => {
                if (row.original.date_joined) {
                    return (
                        <span>
                            {moment(row.original.date_joined).format(
                                'DD/MM/YYYY',
                            )}
                        </span>
                    );
                }
                return null;
            },
        },
        {
            Header: 'Last Booking',
            accessor: 'last_booking_date',
            headerClassName: 'small-col',
            className: 'small-col',
            Cell: row => {
                if (row.original.last_booking_date) {
                    return (
                        <span>
                            {moment(row.original.last_booking_date).format(
                                'DD/MM/YYYY',
                            )}
                        </span>
                    );
                }
                return null;
            },
        },
        {
            Header: 'Self-serve',
            headerClassName: 'small-col',
            className: 'small-col padding-left-10',
            sortable: false,
            Cell: row =>
                row.original.self_serve ? (
                    <i className="icon icon-medium with-margin icon-check-circle-22 green" />
                ) : (
                    <i className="icon icon-medium with-margin icon-remove-circle-11 red" />
                ),
        },
        {
            Header: 'Past',
            headerClassName: 'xsmall-col',
            className: 'xsmall-col',
            accessor: 'total_past_bookings',
        },
        {
            Header: 'Future',
            headerClassName: 'xsmall-col',
            className: 'xsmall-col',
            accessor: 'total_future_bookings',
        },
        {
            Header: 'Category',
            Cell: row => {
                const categoryId = row.original.category;
                return this.state.clientCategories.find(category => category.id === categoryId)?.category;
            },
        },
    ];
}
